import { concat } from 'lodash'
import organizations from './Organizations/organizations.routes'
import profile from './Profile/profile.routes'

const routes = concat(organizations, profile)
export default routes
